import React, {useState, useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import { topicData, setTopic, setTopicComponents } from '../../slices/topicSlice';
import { getTopicComponents } from '../../utils/api-services/topic';
import { pageInitDisplay } from '../../utils/globalUtils';
import TopicCompContainer from './TopicCompContainer';
import TopicComponentListItem from './TopicComponentListItem';

const TopicComponentList = ({code, edit}) => {
    
    const [loading, setLoading] = useState("init");

    const tpicData = useSelector(topicData);
    const dispatch = useDispatch();
    const topicComponents = tpicData.topicComponents;

    useEffect(()=>{
        loadTopicComponents();
    }, []);

    const loadTopicComponents = async () => {
        setLoading("runnig");
        const data = await getTopicComponents(code);
        dispatch(setTopicComponents(data));
        setLoading("completed");
    }

    const displayInit = (
        pageInitDisplay({
            icon: "/images/empty.png",
            title: "Empty Topic Component",
            info: "Click on a component button above to add a component",
            label: "",
            url: ""
        })
    )

    const displayTopicComp = (
        <div className='topic-styles'>
            {topicComponents.map((itm, index)=>(
                <div>
                    {(itm.ComponentType == "container") && 
                        <>
                            <TopicCompContainer 
                                key={itm.Id} 
                                obj={itm} 
                                index={index} 
                                edit={edit} 
                            />
                            {edit && <hr />}
                        </>
                    }
                    {(itm.ComponentType != "container") && 
                        <>
                            <TopicComponentListItem 
                                key={itm.Id} 
                                obj={itm} 
                                index={index} 
                                edit={edit} 
                            />
                            {edit && <hr />}
                        </> 
                    }
                </div>
            ))}
        </div>
    )

    return (
        <div>
            {(loading=="completed") && 
                <div>
                    {(topicComponents.length > 0)?  displayTopicComp:  displayInit}
                </div>
            } 
        </div> 
    )
}

export default TopicComponentList